// extracted by mini-css-extract-plugin
export var cardTitle = "_i2-1";
export var commentBubble = "_i2-e";
export var commentForm = "_i2-a";
export var commentInput = "_i2-b";
export var commentLabel = "_i2-d";
export var commentPrompt = "_i2-9";
export var csatCard = "_i2-0";
export var feedbackSection = "_i2-7";
export var starDisabled = "_i2-6";
export var starEmpty = "_i2-5";
export var starFilled = "_i2-4";
export var starWrapper = "_i2-3";
export var starsContainer = "_i2-2";
export var submittedComment = "_i2-c";
export var thankYouText = "_i2-8";